module.exports = __webpack_public_path__ + "30bfc0f4600cfff2dec09ae4c3847da5.MP3";